import React from "react";
import {
  FaMicrochip,
  FaCheckCircle,
  FaCode,
  FaClipboardCheck,
  FaCogs,
  FaSearch,
  FaClock,
  FaIndustry,
  FaShieldAlt,
  FaRocket,
  FaBolt,
  FaProjectDiagram,
  FaDatabase,
  FaCloud,
  FaLightbulb,
  FaGlobe,
  FaBroadcastTower,
  FaCamera,
  FaRobot,
  FaSolarPanel,
  FaLock,
  FaBell,
  FaTruck,
} from "react-icons/fa";

import "./Featuregrid.css";

interface Feature {
  icon: string;
  title: string;
  description: string;
}

interface FeatureGridProps {
  id?: string;
  title?: string;
  features: Feature[];
  variant?: string;
}

const iconMap: Record<string, any> = {
  FaMicrochip,
  FaCheckCircle,
  FaCode,
  FaClipboardCheck,
  FaCogs,
  FaSearch,
  FaClock,
  FaIndustry,
  FaShieldAlt,
  FaRocket,
  FaBolt,
  FaProjectDiagram,
  FaDatabase,
  FaCloud,
  FaLightbulb,
  FaGlobe,
  FaBroadcastTower,
  FaCamera,
  FaRobot,
  FaSolarPanel,
  FaLock,
  FaBell,
  FaTruck,
};

const getIcon = (name: string): React.ReactNode | null => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Unknown icon: ${name}`);
    return null;
  }

  return <IconComponent className="feature-icon-svg" />;
};

export const FeatureGrid: React.FC<FeatureGridProps> = ({
  title,
  features,
  id,
  variant,
}) => {
  return (
    <section className={`feature-grid-section ${variant || ""}`} id={id}>
      {title ? <h2 className="feature-title">{title}</h2> : null}

      <div className="feature-grid-container">
        {features.map((f, i) => (
          <div key={i} className="feature-card">
            <div className="feature-icon">{getIcon(f.icon)}</div>

            <h3 className="feature-card-title">{f.title}</h3>

            <p className="feature-card-desc">{f.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
